<!--
    Muestra el contenido del componente si existe. Si estuviera vacío, muestra LoaderComponent.
    Se utiliza para contenido que aún no está disponible y se está cargando
-->

<template>
    <div>
        <slot>
            <div style="height: 120px" data-cy="loader">
                <LoaderComponent/>
            </div>            
        </slot>
    </div>
</template>

<script>
    import LoaderComponent from '@/components/preloader/LoaderComponent';

    export default {
        components: {
            LoaderComponent
        }
    }
</script>